import type { Product } from '@model/product'
import { QUANTITY_LIMIT } from '../constants/product'

export const checkOutOfStock = (product: Product, maxQuantity?: number) => {
  const { status } = product
  return status === 0 || !maxQuantity || maxQuantity < 1 || (product?.[QUANTITY_LIMIT] || 0) > maxQuantity
}
